"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumnsOrder = void 0;
const react_1 = require("react");
const ramda_1 = require("ramda");
const use_columns_order_utils_1 = require("./use-columns-order.utils");
const useColumnsOrder = (columns, persistedColumnsOrder, setPersistedColumnsOrder) => {
    const [localColumnsOrder, setLocalColumnsOrder] = (0, react_1.useState)([]);
    const columnsOrder = persistedColumnsOrder !== null && persistedColumnsOrder !== void 0 ? persistedColumnsOrder : localColumnsOrder;
    const setColumnsOrder = (0, react_1.useCallback)((getNextOrder) => {
        if (setPersistedColumnsOrder) {
            const nextOrder = getNextOrder(columnsOrder);
            if (!(0, ramda_1.equals)(nextOrder, columnsOrder)) {
                setPersistedColumnsOrder(nextOrder);
            }
            return;
        }
        setLocalColumnsOrder((previousOrder) => {
            const nextOrder = getNextOrder(previousOrder);
            return (0, ramda_1.equals)(nextOrder, previousOrder) ? previousOrder : nextOrder;
        });
    }, [columnsOrder, setPersistedColumnsOrder]);
    const currentFields = (0, react_1.useMemo)(() => columns.map((column) => String(column.field)), [columns]);
    const effectiveColumnsOrder = (0, react_1.useMemo)(() => (columnsOrder.length === 0 ? currentFields : (0, use_columns_order_utils_1.mergeColumnsOrder)(currentFields, columnsOrder)), [columnsOrder, currentFields]);
    (0, react_1.useEffect)(() => {
        setColumnsOrder((previousOrder) => {
            if (previousOrder.length === 0) {
                return currentFields;
            }
            const nextOrder = (0, use_columns_order_utils_1.mergeColumnsOrder)(currentFields, previousOrder);
            return (0, ramda_1.equals)(nextOrder, previousOrder) ? previousOrder : nextOrder;
        });
    }, [currentFields, setColumnsOrder]);
    const orderedColumns = (0, react_1.useMemo)(() => {
        if (columnsOrder.length === 0)
            return columns;
        const columnMap = new Map(columns.map((column) => [String(column.field), column]));
        const reorderedColumns = effectiveColumnsOrder
            .map((field) => columnMap.get(field))
            .filter((column) => Boolean(column));
        const missingColumns = columns.filter((column) => !effectiveColumnsOrder.includes(String(column.field)));
        return [...reorderedColumns, ...missingColumns];
    }, [columns, columnsOrder.length, effectiveColumnsOrder]);
    const onColumnOrderChange = (0, react_1.useCallback)(({ targetIndex, column }) => {
        setColumnsOrder(() => {
            const fromIndex = effectiveColumnsOrder.findIndex((field) => field === column.field);
            if (fromIndex < 0)
                return effectiveColumnsOrder;
            const nextOrder = [...effectiveColumnsOrder];
            nextOrder.splice(fromIndex, 1);
            const boundedTargetIndex = Math.max(0, Math.min(targetIndex, nextOrder.length));
            nextOrder.splice(boundedTargetIndex, 0, column.field);
            return (0, ramda_1.equals)(nextOrder, effectiveColumnsOrder) ? effectiveColumnsOrder : nextOrder;
        });
    }, [effectiveColumnsOrder, setColumnsOrder]);
    return {
        orderedColumns,
        onColumnOrderChange,
    };
};
exports.useColumnsOrder = useColumnsOrder;
